import React, { useState } from 'react';
import clsx from 'clsx';
import ClickAwayListener from 'react-click-away-listener';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import styles from './FilterPill.module.scss';

interface FilterPillProps {
    label: string;
    icon?: IconDefinition;
    active?: boolean;
    align?: 'left' | 'right';
    size?: 'medium' | 'large';
    className?: string;
    children: (close: () => void) => React.ReactNode;
}

// Outlined filter pill with a popover, matching the Dashboard filters ("All regions ▾", "All locations ▾").
export const FilterPill: React.FC<FilterPillProps> = ({
    label,
    icon,
    active,
    align = 'left',
    size = 'medium',
    className,
    children
}) => {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
        <ClickAwayListener onClickAway={() => open && close()}>
            <div className={clsx(styles.root, className)}>
                <button
                    type="button"
                    className={clsx(styles.pill, styles[size], { [styles.open]: open, [styles.active]: active })}
                    onClick={() => setOpen(prev => !prev)}
                >
                    {icon && <FontAwesomeIcon icon={icon} />}
                    <span className={styles.label}>{label}</span>
                    <FontAwesomeIcon
                        className={styles.chevron}
                        icon={open ? faChevronUp : faChevronDown}
                    />
                </button>

                {open && <div className={clsx(styles.popover, styles[align])}>{children(close)}</div>}
            </div>
        </ClickAwayListener>
    );
};

export default FilterPill;
